export enum SeoLandingPageSection {
  Header = 'header',
  JobSection = 'jobSection',
  Reasons = 'reasons',
  Advantages = 'advantages',
  SalaryEstimation = 'salaryEstimation',
  ApplicationProcess = 'applicationProcess',
  Testimonial = 'testimonial',
  EmployerSection = 'employerSection',
  Faqs = 'faqs',
}

export enum SeoLandingPageMetaData {
  Basic = 'basic',
  Seo = 'seo',
}
